import React from 'react';
import { Provider } from 'react-redux';
import Router from '@/router/router';
import store from '@/redux/stroe';
import { PermissionsProvider } from '@/util/hooks/checkPermissions';

/**
 * 顶层入口已完成远程语言包初始化，AppRoot 只负责挂载全局 Provider 与路由。
 */
const AppRoot: React.FC = () => {
  return (
    <Provider store={store}>
      <PermissionsProvider>
        <Router />
      </PermissionsProvider>
    </Provider>
  );
};

export default AppRoot;
